/**
 * The Django permissions the frontend reads off `/users/me/`. Each one only
 * decides what the UI shows; the API behind it keeps its own check. All are
 * granted in the Django admin.
 */

/** Show the Settings > Feature Flags tab. */
export const VIEW_SETTINGS_FEATURE_FLAGS_TAB_PERMISSION =
  "core.view_settings_feature_flags_tab";

/** Show the Settings > Cache tab. */
export const VIEW_SETTINGS_CACHE_TAB_PERMISSION =
  "core.view_settings_cache_tab";

/** Show the Settings > Secrets tab. */
export const VIEW_SETTINGS_SECRETS_TAB_PERMISSION =
  "vault.view_settings_secrets_tab";

/** Create secrets and change their values and descriptions. */
export const MANAGE_SECRETS_PERMISSION = "vault.manage_secrets";

/** Show the Settings > Integrations tab. */
export const VIEW_SETTINGS_INTEGRATIONS_TAB_PERMISSION =
  "vault.view_settings_integrations_tab";

/** Choose which secret each integration reads. */
export const MANAGE_INTEGRATIONS_PERMISSION = "vault.manage_integrations";

/**
 * One per Settings tab. A user holding none of them has nothing to see in
 * Settings, so the side menu leaves its row out for them.
 */
export const SETTINGS_TAB_PERMISSIONS = [
  VIEW_SETTINGS_FEATURE_FLAGS_TAB_PERMISSION,
  VIEW_SETTINGS_CACHE_TAB_PERMISSION,
  VIEW_SETTINGS_SECRETS_TAB_PERMISSION,
  VIEW_SETTINGS_INTEGRATIONS_TAB_PERMISSION,
];
